import { api } from '../../services/api'

const GEOREVERSE_HERE_BATCH_LIMIT = 100

// Get here multiple reverse geocoded coordinates
// Maximum coordinates per request is 100
export async function batchReverseGeocode (coordinates) {
  let allResults = [] // Array to accumulate results
  let batchForSend = []

  try {
    if (coordinates && coordinates.length) {
      for (let i = 0; i <= coordinates.length; i++) {
        batchForSend.push(coordinates[i])

        if ((batchForSend.length / GEOREVERSE_HERE_BATCH_LIMIT) === 1) {
          const response = await api()['satellite-tracking'].post('here-batch-reverse-geocode', {
            coordinates: batchForSend // Send the current batch
          })

          batchForSend = []
          allResults.push(response.data)
        }
        else if (i === coordinates.length - 1 && batchForSend.length) {
          const response = await api()['satellite-tracking'].post('here-batch-reverse-geocode', {
            coordinates: batchForSend // Send the last remain batch
          })

          batchForSend = []
          allResults.push(response.data)
        }
      }

      allResults = allResults.reduce((finalObj, currentItem) => {
        return { ...finalObj, ...currentItem }
      }, {})

      return allResults
    }

    return {}
  }
  catch (exception) {
    console.error('Multiple reverse geocoding exception occurred:', exception)
  }
}
